import { gql } from '@apollo/client'

export const UpdateCandidateLocationPreferences = gql`
    mutation UpdateCandidateLocationPreferences(
        $candidateId: ID!
        $preferences: [LocationPreferenceInput!]
    ) {
        updateCandidateLocationPreferences(
            candidateId: $candidateId
            preferences: $preferences
        ) {
            success
        }
    }
`

export const UpdateCandidateIndustryPreferences = gql`
    mutation UpdateCandidateIndustryPreferences(
        $candidateId: ID!
        $preferences: [IndustryPreferenceInput!]
    ) {
        updateCandidateIndustryPreferences(
            candidateId: $candidateId
            preferences: $preferences
        ) {
            success
        }
    }
`

export const UpdateCandidateSectorPreferences = gql`
    mutation UpdateCandidateSectorPreferences(
        $candidateId: ID!
        $preferences: [SectorPreferenceInput!]
    ) {
        updateCandidateSectorPreferences(
            candidateId: $candidateId
            preferences: $preferences
        ) {
            success
        }
    }
`

export const UpdateCandidateStartDate = gql`
    mutation UpdateCandidateStartDate(
        $candidateId: ID!
        $startDates: [String!]!
    ) {
        updateCandidateStartDate(
            candidateId: $candidateId
            startDates: $startDates
        ) {
            success
        }
    }
`

export const UpdateCandidateNote = gql`
    mutation UpdateCandidatePreferencesNote(
        $candidateId: ID!
        $templateId: ID!
        $note: String
    ) {
        updateCandidateNote(
            candidateId: $candidateId
            templateId: $templateId
            note: $note
        ) {
            success
            message
        }
    }
`
